const dialogSkin = {
  "@keyframes fadeIn": {
    "0%": { opacity: "0.1" },
    "66%": { opacity: " 0.5" },
    "100%": { opacity: "1" },
  },
  dialog: {
    composes:
      "dialog hidden overflow-y-auto overflow-x-hidden fixed right-0 left-0 top-4 z-50 justify-center items-center h-modal md:h-full md:inset-0 ",
  },
  "dialog-open": {
    ".dialog&": {
      display: "block",
      opacity: "0",
      animation: "$fadeIn 0.15s ease 0s normal forwards 1",
    },
  },
  "dialog-closed": {
    ".dialog&": {
      display: "none",
      opacity: "0",
      animation: "none",
    },
  },
};

export default dialogSkin;
